import React from 'react'
import Layout from 'components/layout'
import Meta from 'components/meta'
import { siteMetadata } from '../../../gatsby-config'
import Lines from 'components/lines'
import Dinamiza from 'components/colorDinamiza'
import Light from 'components/colorLight'
import style from 'scss/pages/posizioniAperte.module.scss'
import ItemPosition from 'components/itemPosition'
import FormContactCareers from "components/formContactCareers";

class WebDeveloperStage extends React.Component{
  render() {

    const { location, data } = this.props

    return(
      <div ref={this.page} className={style.page}>
        <Layout location={location}>
          <Meta site={siteMetadata} title="Web Developer PHP" description={'Cerchiamo un web developer php per la realizzazione di piattaforme e applicazioni web: entra a far parte del team di sviluppo di Dinamiza!'}/>

          <Lines />

          <div className={`container-fluid ${style.page__content}`}>
            <div className={`row`}>
              <div className={`offset-md-2 col-md-2`}>
                <p className={`has-color-primary-negative ${style.page__content__claimLeft}`}><Light>Web Developer PHP in stage</Light></p>
              </div>
              <div className={`offset-md-1 col-md-7 no-padding ${style.page__content__fullScreenSlide}`}>
                <div>

                  <h3>Cerchiamo un Web Developer PHP in stage</h3>

                  <p>Cerchiamo persone entusiaste del web, che si integrino facilmente e proficuamente nel nostro team e
                    che contribuiscano a sviluppare idee aziendali e ad ottimizzare quelle dei clienti. Lo stage è formativo e 
                    finalizzato all'<strong>assunzione</strong>.</p>

                  <p><strong>Cosa abbiamo pensato per te:</strong></p>

                  <p>Abbiamo diversi progetti su cui cimentarsi, sia riguardo lo sviluppo web orientato alla comunicazione 
                    che nello sviluppo software sia back-end che front-end. 
                    Richiediamo una formazione tecnica e la conoscenza di base degli strumenti da utilizzare.</p>

                  <p><strong>Competenze gradite:</strong><br/>
                  Richiediamo almeno alcune delle competenze di quelle elencate per poter individuare più velocemente
                  un percorso formativo mirato all'assunzione.</p>
                  <ul className="lista_generica lista_competenze">
                    <li>Conoscenza dell’Object-Oriented Programming</li>
                    <li>Conoscenza di PHP, MySQL</li>
                    <li>Conoscenza di HTML 5, CSS, JavaScript o qualche framework Js</li>
                    <li>Familiarità con l’ambiente Unix/Linux e lo stack LAMP</li>
                    <li>Conoscenza di Drupal o Wordpress o Shopify o Prestashop</li>
                    <li>Conoscenza di framework Symfony o Laravel</li>
                    <li>Conoscenza di sistemi di versioning (git)</li>
                    <li>Buona conoscenza della lingua inglese scritta</li>
                    <li>Tanta voglia di imparare 😉</li>
                  </ul>

                  <h4 className={'title'}>Inviaci il curriculum</h4>
                  <FormContactCareers position={'RIF.53 - Web Developer PHP in stage'} />

                </div>
              </div>
            </div>
            <div className={`offset-md-5 col-md-7 no-padding ${style.page__content__fullScreenSlide__arrow}`}></div>
          </div>
        </Layout>
      </div>
    )
  }
}

export default WebDeveloperStage
